/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EncounterResponseModel } from '../models';
// @ts-ignore
import type { EncounterSearch } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { SearchFhirEncounters200Response } from '../models';
/**
 * FHIREncounterApi - axios parameter creator
 * @export
 */
export const FHIREncounterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get encounter by encounter id
         * @summary Get encounter by encounter id
         * @param {string} encounterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterById: async (encounterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'encounterId' is not null or undefined
            assertParamExists('getEncounterById', 'encounterId', encounterId)
            const localVarPath = `/api/v1/fhir/encounter/getById/{encounterId}`
                .replace(`{${"encounterId"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get encounters by patient id
         * @summary Get encounters by patient id
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncountersByPatientId: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getEncountersByPatientId', 'patientId', patientId)
            const localVarPath = `/api/v1/fhir/encounter/getByPatient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search encounters with advanced filters
         * @summary Search encounters
         * @param {EncounterSearch} encounterSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFhirEncounters: async (encounterSearch: EncounterSearch, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'encounterSearch' is not null or undefined
            assertParamExists('searchFhirEncounters', 'encounterSearch', encounterSearch)
            const localVarPath = `/api/v1/fhir/encounter/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(encounterSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FHIREncounterApi - functional programming interface
 * @export
 */
export const FHIREncounterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FHIREncounterApiAxiosParamCreator(configuration)
    return {
        /**
         * Get encounter by encounter id
         * @summary Get encounter by encounter id
         * @param {string} encounterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEncounterById(encounterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EncounterResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEncounterById(encounterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIREncounterApi.getEncounterById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get encounters by patient id
         * @summary Get encounters by patient id
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEncountersByPatientId(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EncounterResponseModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEncountersByPatientId(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIREncounterApi.getEncountersByPatientId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search encounters with advanced filters
         * @summary Search encounters
         * @param {EncounterSearch} encounterSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFhirEncounters(encounterSearch: EncounterSearch, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchFhirEncounters200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFhirEncounters(encounterSearch, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIREncounterApi.searchFhirEncounters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FHIREncounterApi - factory interface
 * @export
 */
export const FHIREncounterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FHIREncounterApiFp(configuration)
    return {
        /**
         * Get encounter by encounter id
         * @summary Get encounter by encounter id
         * @param {FHIREncounterApiGetEncounterByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterById(requestParameters: FHIREncounterApiGetEncounterByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<EncounterResponseModel> {
            return localVarFp.getEncounterById(requestParameters.encounterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get encounters by patient id
         * @summary Get encounters by patient id
         * @param {FHIREncounterApiGetEncountersByPatientIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncountersByPatientId(requestParameters: FHIREncounterApiGetEncountersByPatientIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EncounterResponseModel>> {
            return localVarFp.getEncountersByPatientId(requestParameters.patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search encounters with advanced filters
         * @summary Search encounters
         * @param {FHIREncounterApiSearchFhirEncountersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFhirEncounters(requestParameters: FHIREncounterApiSearchFhirEncountersRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchFhirEncounters200Response> {
            return localVarFp.searchFhirEncounters(requestParameters.encounterSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FHIREncounterApi - interface
 * @export
 * @interface FHIREncounterApi
 */
export interface FHIREncounterApiInterface {
    /**
     * Get encounter by encounter id
     * @summary Get encounter by encounter id
     * @param {FHIREncounterApiGetEncounterByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIREncounterApiInterface
     */
    getEncounterById(requestParameters: FHIREncounterApiGetEncounterByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<EncounterResponseModel>;

    /**
     * Get encounters by patient id
     * @summary Get encounters by patient id
     * @param {FHIREncounterApiGetEncountersByPatientIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIREncounterApiInterface
     */
    getEncountersByPatientId(requestParameters: FHIREncounterApiGetEncountersByPatientIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EncounterResponseModel>>;

    /**
     * Search encounters with advanced filters
     * @summary Search encounters
     * @param {FHIREncounterApiSearchFhirEncountersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIREncounterApiInterface
     */
    searchFhirEncounters(requestParameters: FHIREncounterApiSearchFhirEncountersRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchFhirEncounters200Response>;

}

/**
 * Request parameters for getEncounterById operation in FHIREncounterApi.
 * @export
 * @interface FHIREncounterApiGetEncounterByIdRequest
 */
export interface FHIREncounterApiGetEncounterByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIREncounterApiGetEncounterById
     */
    readonly encounterId: string
}

/**
 * Request parameters for getEncountersByPatientId operation in FHIREncounterApi.
 * @export
 * @interface FHIREncounterApiGetEncountersByPatientIdRequest
 */
export interface FHIREncounterApiGetEncountersByPatientIdRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIREncounterApiGetEncountersByPatientId
     */
    readonly patientId: string
}

/**
 * Request parameters for searchFhirEncounters operation in FHIREncounterApi.
 * @export
 * @interface FHIREncounterApiSearchFhirEncountersRequest
 */
export interface FHIREncounterApiSearchFhirEncountersRequest {
    /**
     * 
     * @type {EncounterSearch}
     * @memberof FHIREncounterApiSearchFhirEncounters
     */
    readonly encounterSearch: EncounterSearch

    /**
     * 
     * @type {number}
     * @memberof FHIREncounterApiSearchFhirEncounters
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof FHIREncounterApiSearchFhirEncounters
     */
    readonly pgSize?: number
}

/**
 * FHIREncounterApi - object-oriented interface
 * @export
 * @class FHIREncounterApi
 * @extends {BaseAPI}
 */
export class FHIREncounterApi extends BaseAPI implements FHIREncounterApiInterface {
    /**
     * Get encounter by encounter id
     * @summary Get encounter by encounter id
     * @param {FHIREncounterApiGetEncounterByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIREncounterApi
     */
    public getEncounterById(requestParameters: FHIREncounterApiGetEncounterByIdRequest, options?: RawAxiosRequestConfig) {
        return FHIREncounterApiFp(this.configuration).getEncounterById(requestParameters.encounterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get encounters by patient id
     * @summary Get encounters by patient id
     * @param {FHIREncounterApiGetEncountersByPatientIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIREncounterApi
     */
    public getEncountersByPatientId(requestParameters: FHIREncounterApiGetEncountersByPatientIdRequest, options?: RawAxiosRequestConfig) {
        return FHIREncounterApiFp(this.configuration).getEncountersByPatientId(requestParameters.patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search encounters with advanced filters
     * @summary Search encounters
     * @param {FHIREncounterApiSearchFhirEncountersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIREncounterApi
     */
    public searchFhirEncounters(requestParameters: FHIREncounterApiSearchFhirEncountersRequest, options?: RawAxiosRequestConfig) {
        return FHIREncounterApiFp(this.configuration).searchFhirEncounters(requestParameters.encounterSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }
}

